import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 9 9",
  fill: "white",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.75 4.5C0.75 4.17895 0.966231 3.75 1.41667 3.75H6.08333C6.53377 3.75 6.75 4.17895 6.75 4.5V7.875C6.75 8.19605 6.53377 8.625 6.08333 8.625H1.41667C0.966231 8.625 0.75 8.19605 0.75 7.875V4.5Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.89844 1.375C3.31331 1.375 2.77344 1.91516 2.77344 2.66667V4C2.77344 4.20711 2.60554 4.375 2.39844 4.375C2.19133 4.375 2.02344 4.20711 2.02344 4V2.66667C2.02344 1.57723 2.82672 0.625 3.89844 0.625C4.97015 0.625 5.77344 1.57723 5.77344 2.66667V4C5.77344 4.20711 5.60554 4.375 5.39844 4.375C5.19133 4.375 5.02344 4.20711 5.02344 4V2.66667C5.02344 1.91516 4.48356 1.375 3.89844 1.375Z"
    }, null, -1)
  ]))]))
}
export default { render: render }